<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="message" style="position:relative;height: 100%; min-height: 726px;background: #fff;">
        <div class="message-title">
            <span class="myTitle" style="margin-left:25px">消息通知</span>
        </div>
        <div v-if="records.length>0">
            <ul class="message-ul" style="cursor:pointer">
                <li v-for="(item,index) in records" :key="index" @click="chageStatus(item)">
                    <p style="padding-top:20px;display: flex;">
                        <img v-if="item.status==0" src="./images/news3.png" alt='版权登记'/>
                        <img v-if="item.status==1" src="./images/news1.png" alt='版权登记'/>
                        <span class="span1">{{item.messageTitle}}</span>
                        <span class="span2">{{item.createDate}}</span>
                    </p>
                    <p style="color:rgba(128,130,135,1);margin-left:43px;">{{item.messageContent}}</p>
                </li>
            </ul>
            <div style="height:80px"></div>
            <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                <span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" style="margin-top:120px" alt='版权登记'/>
            <p>表单暂无数据哦～</p>
        </div>
    </div>
</template>

<script>
import { _getByPage } from "@/api/message.js";
import Cookies from "js-cookie";
    export default {
        metaInfo: {
            title: '消息通知|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '消息通知,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name:'message',
        data(){
            return{
                total:0,
                pages:1,
                pageNumber:1,
                pageSize: 8,
                records:[],
                status:null,
                flag:false
            }
        },
        methods: {
           getByPage(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data = {
                   pageNumber:this.pageNumber,
                   pageSize:this.pageSize,
                   sort:'a.create_date',
                   order:'desc',
                   registerId:userInfo && userInfo.id?userInfo.id:''
                }
                _getByPage(data).then(res => {
                    if(res.code==200){
                       this.records=res.result.records;
                       this.total=Number(res.result.total);
                       this.pages=res.result.pages;
                       this.flag=true;
                    }
                });
            },
            changepage(index){
                this.pageNumber = index
                this.getByPage()
            },
            chageStatus(item){
                this.getRequest('/message/updateMessageStatus/'+item.id).then(res=>{
                    if(res.code==200){
                        this.getByPage()
                    }
                })
            }
        },
        mounted() {
            this.getByPage()
        },
    }
</script>
<style scoped lang="less">
.message{


    background:rgba(255,255,255,1);
    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    border-radius:8px;
    margin: 0 0 0 25px;
    .message-title{

        height:63px;
        line-height: 63px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:8px 8px 0px 0px;
        font-size:14px;
        color:rgba(51,51,51,1);
    }
    .message-ul{

        li{

            min-height:92px;
            border-bottom:1px solid #F4F5F5;
            font-size: 14px;
            margin:0 30px;
            list-style:none;
            p{
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 9px;
                img{
                    width:23px;
                    height: 23px;
                    vertical-align: middle;
                    margin-right: 20px;
                }
                .span1{
                    font-weight:600;
                    color:rgba(97,97,97,1);
                    line-height:20px;
                    display: inline-block;
                    width: 700px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .span2{
                    font-weight:400;
                    color:rgba(177,177,177,1);
                    line-height:20px;
                    float: right;
                }
            }
        }

    }
}
.myTitle{
    font-size: 18px !important;
    font-weight: 700;
    position: relative;
    z-index: 2;
    color: #333 !important;
    &::before{
        content: '';
        position: absolute;
        width: 50px;
        background: #2196F3;
        height: 6px;
        border-radius: 3px;
        left: 0;
        bottom: 0 !important;
        z-index: -1;
    }
}
</style>
